enum AccountStatus {
  SYNC = 'SYNC',
  ANY = 'ANY',
}

export async function getChromeProfileEmail(): Promise<string> {
  console.log('Getting profile email from Chrome');
  return new Promise(resolve => {
    const callback = (userInfo: chrome.identity.UserInfo) => {
      console.log('User info from chrome profile:', userInfo);
      resolve(userInfo.email);
    };
    try {
      chrome.identity.getProfileUserInfo({ accountStatus: AccountStatus.ANY }, callback);
    } catch (ex: unknown) {
      // Account Status is not supported for old Chrome versions
      console.error('Error getting profile email for outdated Chrome, please update it: ', ex);
      chrome.identity.getProfileUserInfo(callback);
    }
  });
}
